import React, { useEffect, useRef, useState } from "react";
import { Container, Form, Button, Table, Modal } from "react-bootstrap";
import { FaEdit, FaTrashAlt, FaEye } from "react-icons/fa";
import DashboardLayout from "../DashboardLayout";
import { useFormik } from "formik";
import { homePageValidations } from "./validations";
import { handleErrors } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import {
  addPageContent,
  deletePageById,
  fetchPageContentList,
  getAllPagesList,
  togglePageStatus,
  updatePage,
} from "../../services/axios/apiManager";
import BSPagination from "../../Components/pagination";
import { toast } from "sonner";
import LoadingSpinner from "../../Components/spinner";
import PageDetailsModal from "./detailsModal";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "summernote/dist/summernote-lite.css";
import "summernote/dist/summernote-lite.js";

function HomePage() {
  const navigate = useNavigate();
  const pageCode = "home"; // // //Dont ever change it😁.
  const [loading, setLoading] = useState(false);
  const [mainPageId, setMainPageId] = useState(null);
  const [pagesList, setPagesList] = useState([]);
  const [mainPages, setMainPages] = useState([]);
  const [pagination, setPagination] = useState({});
  const [modalOptions, setModalOptions] = useState({});
  const [selectedPage, setSelectedPage] = useState(null);
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [pageForDetails, setPageForDetails] = useState(null);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [content, setContent] = useState("");
  const editorRef = useRef(null);
  const tableRef = useRef(null);

  const getPagesList = async (
    page = pagination.currentPage || 1,
    pageSize = pagination.pageSize || 5
  ) => {
    const res = await fetchPageContentList(pageCode, page, pageSize);
    if (res?.data?.success && res?.data?.data) {
      setPagesList(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      handleErrors(res, navigate, "Pages List: ");
    }
  };

  const handlePageChange = async (page) => {
    const temp = { ...pagination };
    setPagination((prev) => ({ ...prev, currentPage: page }));
    temp.currentPage = page;
    await getPagesList(temp);
  };

  // // // Change status Logic
  const handleStatusChange = async (pge) => {
    setModalOptions({
      header: "Change Status",
      body: `Are you sure you want to change the status of "${pge.heading}"?`,
      okay: "Change",
      method: changeStatus,
      data: {
        id: pge.id,
        status: pge.status === 1 ? 0 : 1,
        page_id: pge.page_id,
      },
    });
    setShowOptionsModal(true);
  };

  const changeStatus = async (data) => {
    const response = await togglePageStatus(data);
    if (response?.data?.success === true) {
      await getPagesList(pagination?.currentPage, pagination?.pageSize);
    }
    setModalOptions({});
    setShowOptionsModal(false);
  };

  // // // Delete Role logic
  const handleDeletePage = (pge) => {
    setModalOptions({
      header: "Delete Page",
      body: `Are you sure you want to delete "${pge.heading}"?`,
      okay: "Delete",
      method: deletePage,
      data: { id: pge.id },
    });
    setShowOptionsModal(true);
  };

  const deletePage = async (data) => {
    if (data.id) {
      const response = await deletePageById(data.id);
      if (response?.data?.success && response?.data?.data === 1) {
        await getPagesList(pagination?.currentPage, pagination?.pageSize);
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        setModalOptions({});
        setShowOptionsModal(false);
      }
    }
  };

  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };
  const getAllMainPages = async () => {
    const res = await getAllPagesList();
    if (res?.data?.success && res?.data?.data) {
      setMainPages(res.data.data);
      const temp = res.data.data.find((f) => f.page_code === pageCode)?.id;
      setMainPageId(temp);
    } else {
      handleErrors(res, navigate, "Pages List: ");
    }
  };

  const formik = useFormik({
    initialValues: {
      heading: selectedPage?.heading || "",
      content: selectedPage?.content || "",
      section: selectedPage?.section || "section",
      status: selectedPage?.status || 0,
      page_id: mainPageId,
    },
    enableReinitialize: true,
    validationSchema: homePageValidations,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        if (selectedPage?.id) {
          const res = await updatePage({
            id: selectedPage.id,
            ...values,
          });
          if (res?.data?.success) {
            await getPagesList(pagination?.currentPage, pagination?.pageSize);
            toast.success("Page has been updated", { duration: 2000 });
            setSelectedPage(null);
            setContent(null);
            $(editorRef.current).summernote("code", "");
            resetForm();
          } else {
            handleErrors(res, navigate, "Update Page: ");
          }
        } else {
          const res = await addPageContent(values);
          if (res?.data?.success) {
            await getPagesList(pagination?.currentPage, pagination?.pageSize);
            toast.success("Page has been added", { duration: 2000 });
            setSelectedPage(null);
            setContent(null);
            $(editorRef.current).summernote("code", "");
            resetForm();
          } else {
            handleErrors(res, navigate, "Add Page: ");
          }
        }
      } catch (error) {
        console.log("Error Upon form submition", error);
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    getPagesList();
    getAllMainPages();
  }, []);

  useEffect(() => {
    $(editorRef.current).summernote({
      placeholder: "Enter content...",
      tabsize: 2,
      toolbar: [
          ["style", ["style"]],
          ["font", ["bold", "underline", "clear"]],
          ["color", ["color"]],
          ["para", ["ul", "ol", "paragraph"]],
          ["table", ["table"]],
          ["insert", ["link", "picture", "video"]],
          ["view", ["fullscreen", "codeview", "help"]],
        ],
      colors: [
        [
          "#FFB6C1",
          "#FFD700",
          "#ADFF2F",
          "#87CEFA",
          "#E6E6FA",
          "#FFA07A",
          "#F0E68C",
          "#FFDEAD",
          "#FFFACD",
          "#FFEC8B",
        ],
        [
          "#F5DEB3",
          "#FF6347",
          "#40E0D0",
          "#98FB98",
          "#FF69B4",
          "#DA70D6",
          "#B0E0E6",
          "#FFE4B5",
          "#FFDAB9",
          "#FFCCE5",
        ],
        [
          "#FAFAD2",
          "#E0FFFF",
          "#D8BFD8",
          "#FFFAF0",
          "#F0FFF0",
          "#F0F8FF",
          "#F5F5DC",
          "#FFF0F5",
          "#E6E6FA",
          "#FFF5EE",
        ],
      ],
      callbacks: {
        onChange: function (contents) {
          setContent(contents);
          formik.setFieldValue("content", contents);
        },
      },
    });
          $(".note-editable").css({
            "background-color": "transparent",
            color: "#fff",
            "min-height": "100px",
          });
    
          if ($("#summernote-custom-styles").length === 0) {
            $("<style id='summernote-custom-styles'>")
              .prop("type", "text/css")
              .html(
                `
                .note-editable ul {
                  list-style-type: disc !important;
                  padding-left: 40px !important;
                }
                .note-editable ol {
                  list-style-type: decimal !important;
                  padding-left: 40px !important;
                }
                .note-editable li {
                  display: list-item !important;
                }
              `,
              )
              .appendTo("head");
          }
    
          $(".note-toolbar").addClass("summernote-toolbar");

    return () => {
      $(editorRef.current).summernote("destroy");
    };
  }, []);
  useEffect(() => {
    // build each row
    const data = pagesList.map((p) => {
      const head = `<div class="content-preview">${p.heading}</div>`;
      const body = `<div class="content-preview">${p.content}</div>`;
      const status = `
      <button class="btn btn-sm status-btn ${
        p.status === 1 ? "text-success" : "text-danger"
      }" data-id="${p.id}" title="change status">
        ${p.status === 1 ? "Active" : "Inactive"}
      </button>`;
      const acts =
        `<button class="btn btn-sm btn-outline-success me-1 view-btn"  data-id="${p.id}" title="view details"><i class="fas fa-eye"></i></button>` +
        `<button class="btn btn-sm btn-outline-primary me-1 edit-btn" data-id="${p.id}" title="edit"><i class="fas fa-edit"></i></button>` +
        (p.status === 0
          ? `<button class="btn btn-sm btn-outline-danger delete-btn"    data-id="${p.id}" title="delete"><i class="fas fa-trash-alt"></i></button>`
          : "");
      return [head, body, status, acts];
    });

    const cfg = {
      data,
      columns: [
        { title: "Heading" },
        { title: "Content" },
        { title: "Status", className: "text-end", orderable: false },
        { title: "Actions", className: "text-end", orderable: false },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
      pageLength: pagination.pageSize || 10,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().clear().rows.add(data).draw();
    } else {
      $(tableRef.current).DataTable(cfg);
    }

    const $tbl = $(tableRef.current);
    $tbl
      .off("click", ".view-btn")
      .on("click", ".view-btn", (e) => {
        const id = +$(e.currentTarget).data("id");
        const page = pagesList.find((p) => p.id === id);
        setPageForDetails(page);
        setOpenDetailsModal(true);
      })
      .off("click", ".edit-btn")
      .on("click", ".edit-btn", (e) => {
        const id = +$(e.currentTarget).data("id");
        const page = pagesList.find((p) => p.id === id);
        // populate your form and Summernote:
        setSelectedPage(page);
        setContent(page.content);
        $(editorRef.current).summernote("code", page.content);
      })
      .off("click", ".delete-btn")
      .on("click", ".delete-btn", (e) => {
        const id = +$(e.currentTarget).data("id");
        const page = pagesList.find((p) => p.id === id);
        handleDeletePage(page);
      })
      .off("click", ".status-btn")
      .on("click", ".status-btn", (e) => {
        const id = +$(e.currentTarget).data("id");
        const page = pagesList.find((p) => p.id === id);
        handleStatusChange(page);
      });

    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
  }, [pagesList, pagination.pageSize]);

  return (
    <DashboardLayout>
      <Container className="mt-5">
        <div className="bg-dark p-2 rounded mb-4">
          <h3 className="text-light">Home Page Content</h3>
          <Form>
            <div className="row">
              <div className="col-lg-12">
                <Form.Group className="mb-3">
                  <Form.Label className="text-secondary">Section Heading</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter main heading "
                    className="bg-dark text-light border-light input-placeholder-light"
                    {...formik.getFieldProps("heading")}
                    isInvalid={
                      formik.touched.heading && !!formik.errors.heading
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.heading}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
              <div className="col-lg-12">
                <Form.Group className="mb-3">
                  <Form.Label className="text-secondary">Section Content</Form.Label>
                  <div
                    ref={editorRef}
                    className="bg-dark text-light border-light input-placeholder-light"
                  />
                </Form.Group>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              {loading && (
                <div className="mt-3">
                  <LoadingSpinner size={"md"} />
                </div>
              )}

              <Button
                type="button"
                variant="secondary"
                className="mt-3 mx-2"
                onClick={() => {
                  setSelectedPage(null);
                  setContent(null);
                  $(editorRef.current).summernote("code", "");
                  formik.resetForm();
                }}
              >
                Reset Form
              </Button>
              <Button
                type="button"
                variant="success"
                className="mt-3"
                onClick={() => {
                  formik.handleSubmit();
                }}
              >
                {selectedPage?.id ? "Update Page" : "Add Page"}
              </Button>
            </div>
          </Form>
        </div>
        <div className="bg-dark p-4 rounded mb-4">
          <div className="table-responsive mt-4">
            <table
              ref={tableRef}
              className="table table-striped table-dark w-100"
            />

            <div className="constainer-fluid">
              <div className="d-flex justify-content-end">
                <div className="mx-4 py-2">
                  <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
                </div>
                <BSPagination
                  currentPage={pagination?.currentPage}
                  totalPages={pagination?.totalPages}
                  onPageChange={handlePageChange}
                  siblingCount={2}
                  showFirstLast={true}
                />
              </div>
            </div>
          </div>
          {/* //////////////Details Modal///////////////// */}
          <PageDetailsModal
            selectedPage={pageForDetails}
            setSelectedPage={setPageForDetails}
            openDetailsModal={openDetailsModal}
            setOpenDetailsModal={setOpenDetailsModal}
          />
          {/* //////////////Status and Delete Modal///////////////// */}
          <Modal
            show={showOptionsModal}
            onHide={handleCloseOptionsModal}
            centered
            className="text-light"
          >
            <Modal.Header closeButton className="bg-dark text-light border-0">
              <Modal.Title>{modalOptions.header}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-dark text-light">
              {modalOptions.body}
            </Modal.Body>
            <Modal.Footer className="bg-dark text-light border-0">
              <Button variant="secondary" onClick={handleCloseOptionsModal}>
                Cancel
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  modalOptions.method(modalOptions.data);
                }}
              >
                {modalOptions.okay}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </Container>
    </DashboardLayout>
  );
}

export default HomePage;
